<template>
  <b-form-input
    :key="updatesCounter"
    class="input-control"
    :size="size"
    :placeholder="placeholder"
    :min="min"
    :max="max"
    :disabled="disabled"
    :value="displayValue"
    @update="handleInputDebounced"
    @keypress="handleKeypress"/>
</template>


<script>
import debounce from 'lodash-es/debounce'
import { formatVolume } from "@/shared/number-utils"

export default {
  name: 'formatted-number-input',

  props: {
    value: {
      type: Number,
      default: 0,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    min: {
      type: Number,
      default: 0,
    },

    max: {
      type: Number,
      default: 100,
    },

    placeholder: {
      type: String,
      default: 'Number',
    },

    size: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      internalValue: this.value,
      displayValue: formatVolume(this.value, '1000b'),
      updatesCounter: 0,
    };
  },

  methods: {
    handleInputDebounced: debounce(
      function (formattedValue) {
        this.handleInput(formattedValue);
      },
      1000
    ),

    handleInput(formattedValue) {
      this.internalValue = this.getCleanedInternalValue(formattedValue)

      this.$emit('input', this.internalValue);
      this.displayValue = formatVolume(this.internalValue, '1000b');

      // when displayValue remains the same <b-form-input> component doesn't update
      // for example when you enter more than "max" a few times,
      // this case it's needed to force update <b-form-input>
      this.updatesCounter += 1;
    },

    getCleanedInternalValue(inputValue) {
      const value = parseInt(String(inputValue).replace(/[^.\d]/g, ''));

      if(!value) {
        return 0;
      }
      if(value > this.max) {
        return this.max;
      }
      if(value < this.min) {
        return this.min;
      }

      return value;
    },

    handleKeypress($event) {
      // only numbers are allowed to enter
      const keyCode = $event.keyCode;
      if(keyCode >= 48 && keyCode <= 57) {
        return true;
      } else {
        $event.preventDefault();
      }
    },
  },

  watch: {
    value(value) {
      // reflect external changes from props, no need to send events this case
      this.internalValue = this.getCleanedInternalValue(value);
      this.displayValue = formatVolume(this.internalValue, '1000b');
    },
  },
}
</script>

<style scoped>

</style>
